import { render, staticRenderFns } from "./WidgetLoader.vue?vue&type=template&id=219756cc"
import script from "./WidgetLoader.vue?vue&type=script&lang=js"
export * from "./WidgetLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports